import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import { GET_CUSTOMERS_DATA } from '../../../GraphQL/TestExecutions/TRFX/Queries';
import { GET_IMPLEMENTED_COMPONENTS } from '../../../GraphQL/ManageUrls/TRFX/Queries';
import { UPDATE_IMPLEMENTED_WC_CLIENTS } from '../../../GraphQL/TestExecutions/TRFX/Mutations';
import './Form.css';

function ClientComponentForm() {
  const navigate = useNavigate();
  const errorHandler = (error) => {
    window.flash(error, 'error');
  };

  const [runMutation] = useMutation(UPDATE_IMPLEMENTED_WC_CLIENTS);
  const [customerIds, setCustomerIds] = useState([]);
  const [selectedComponent, setSelectedComponent] = useState('');
  const [selectedPublisher, setSelectedPublisher] = useState('');
  const [components, setComponents] = useState([]);
  const [implementedCmpCustomers, SetImplementedCmpCustomers] = useState({});
  const [options, setOptions] = useState([]);
  const [immutableOptions, setImmutableOptionsOptions] = useState([]);

  const implementedWcApplication = [{ label: 'TRFX', value: 'TRFX' }];
  const [selectedApplication, setSelectedApplication] = useState('TRFX');

  const implementedWcPublisher = [
    { label: 'VG', value: 'vg' },
    { label: 'AIRMODULES', value: 'airmodules' },
    { label: 'TRFX', value: 'trfx' },
  ];

  useQuery(GET_CUSTOMERS_DATA, {
    onCompleted: (data) => {
      if (data.customerFindMany !== null) {
        const customerFindMany = data.customerFindMany.reduce(
          (acc, customer) => {
            acc.push({
              label: customer.name,
              value: customer.code,
            });
            return acc;
          },
          []
        );
        setOptions(customerFindMany);
        setImmutableOptionsOptions(customerFindMany);
      } else {
        errorHandler('No customers defined');
      }
    },
    onError: (error) => errorHandler(error.message),
  });

  useQuery(GET_IMPLEMENTED_COMPONENTS, {
    onCompleted: (data) => {
      if (data.implementedWCFindMany !== null) {
        setComponents(
          (data.implementedWCFindMany || []).map((d) => ({
            label: d.name,
            value: d.name,
          }))
        );
        SetImplementedCmpCustomers(
          data.implementedWCFindMany.reduce((acc, implementedWc) => {
            acc[
              `${implementedWc?.name}${implementedWc?.application}${implementedWc?.publisher}`
            ] = implementedWc.implementedClients;
            return acc;
          }, {})
        );
      } else {
        errorHandler('No customers defined');
      }
    },
    onError: (error) => errorHandler(error.message),
  });

  const onSubmit = (event) => {
    event.preventDefault();
    if (
      !customerIds.length ||
      !selectedComponent ||
      !selectedApplication ||
      !selectedPublisher
    ) {
      errorHandler('Complete all fields!!!');
      return;
    }

    runMutation({
      variables: {
        component: selectedComponent,
        application: selectedApplication,
        publisher: selectedPublisher,
        clients: customerIds,
      },
    })
      .then((r) => {
        const response = r.data.implementedWCUpdateOneImplementedClients;
        if (response === null) {
          window.hideMessage();
          window.flash('Component not found. Customers cant be added', 'error');
        } else {
          window.hideMessage();
          window.flash(
            `Customers successfully added to ${selectedComponent}`,
            'success'
          );
          setTimeout(() => {
            window.location.reload(false);
          }, 3000);
        }
      })
      .catch((error) => {
        window.hideMessage();
        window.flash('An error occurred. Customers cant be added', 'error');
      });
  };

  const selectOnchange = (e) => {
    setCustomerIds(e.value);
  };

  const onchangeComponent = (e) => {
    setSelectedComponent(e.value);
    if (selectedApplication && selectedPublisher) {
      const cmpCustomers =
        implementedCmpCustomers[
          `${e.value}${selectedApplication}${selectedPublisher}`
        ];
      if (cmpCustomers !== undefined) {
        setOptions(
          options.reduce((acc, customer) => {
            if (!cmpCustomers.includes(customer.value)) {
              acc.push(customer);
            }
            return acc;
          }, [])
        );
      } else setOptions(immutableOptions);
    } else setOptions(immutableOptions);
  };

  const onchangeApplication = (e) => {
    setSelectedApplication(e.value);
  };

  const onchangePublisher = (e) => {
    setSelectedPublisher(e.value);
    if (selectedApplication && selectedComponent) {
      const cmpCustomers =
        implementedCmpCustomers[
          `${selectedComponent}${selectedApplication}${e.value}`
        ];
      if (cmpCustomers !== undefined) {
        setOptions(
          options.reduce((acc, customer) => {
            if (!cmpCustomers.includes(customer.value)) {
              acc.push(customer);
            }
            return acc;
          }, [])
        );
      } else setOptions(immutableOptions);
    } else setOptions(immutableOptions);
  };

  return (
    <div className='client-form-container'>
      <div className='client-form-card'>
        <form onSubmit={onSubmit} className='client-form'>
          <div className='field'>
            <Dropdown
              id='ss-component'
              value={selectedComponent}
              options={components}
              onChange={onchangeComponent}
              placeholder='Component'
            />
          </div>
          <div className='client-form-field'>
            <Dropdown
              id='ss-application'
              value={selectedApplication}
              options={implementedWcApplication}
              onChange={onchangeApplication}
              placeholder='Application'
            />
            <Dropdown
              id='ss-publisher'
              value={selectedPublisher}
              options={implementedWcPublisher}
              onChange={onchangePublisher}
              placeholder='Publisher'
            />
          </div>
          <div className='field'>
            <MultiSelect
              id='ms-customer'
              value={customerIds}
              options={options}
              onChange={selectOnchange}
              placeholder='Select customers'
              filter
              maxSelectedLabels={3}
              showSelectAll
              style={{ width: '100%' }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '0.75rem',
            }}
          >
            <Button
              label='Cancel'
              icon='pi pi-times'
              onClick={() => navigate('/trfx-test-executions')}
              outlined
            />
            <Button
              label='Accept'
              icon='pi pi-check'
              type='submit'
              severity='primary'
            />
          </div>
        </form>
      </div>
    </div>
  );
}

export default ClientComponentForm;
